export const now = () => new Date().toISOString();
